import React, { useCallback, useEffect, useState } from "react";
import { Hammer, Send, CalendarDays, Gauge, Zap, HardHat, Palette, Ruler, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import EnvoiPoseFlowModal from "./EnvoiPoseFlowModal";

const fmtDate = (v) => (v ? new Date(`${String(v).slice(0, 10)}T12:00:00`).toLocaleDateString("fr-FR") : null);
const num = (v, unit) => (v === null || v === undefined || v === "" ? null : `${Number(v).toLocaleString("fr-FR")} ${unit}`);

function rowsFor(produit, v, sousTraitant) {
  const st = { icon: HardHat, label: "Sous-traitant", value: v.poseur || sousTraitant };
  const date = { icon: CalendarDays, label: "Date de pose", value: fmtDate(v.date_pose) };
  if ((produit || "").toUpperCase() === "ITE") {
    return [{ icon: Ruler, label: "Surface", value: num(v.surface_finale_ite ?? v.metrage, "m²") }, date,
      { icon: Palette, label: "Couleur crépi", value: v.couleur_crepi }, st];
  }
  const isPac = (produit || "").toUpperCase().startsWith("PAC");
  return [{ icon: Gauge, label: "Puissance", value: isPac ? num(v.puissance_kw, "kW") : num(v.puissance_kwc, "kWc") }, date,
    { icon: Zap, label: "Compteur", value: v.type_compteur }, st];
}

export default function InstallationSyntheseCard({ dossier }) {
  const [values, setValues] = useState(null);
  const [open, setOpen] = useState(false);
  const [sentNow, setSentNow] = useState({});
  const load = useCallback(() => api.get(`/dossiers/${dossier.id}/tab-data/installation`).then((r) => setValues(r.data.values || {})).catch(() => setValues({})), [dossier.id]);
  useEffect(() => { load(); }, [load]);
  if (!values) return null;
  const rows = rowsFor(dossier.produit, values, dossier.sous_traitant);
  const ep = { ...(dossier.envoi_pose || {}), ...sentNow };
  const last = ep.email_sent_at || ep.whatsapp_sent_at;
  return (
    <div className="card-flat p-5" data-testid="installation-synthese-card">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div className="overline flex items-center gap-1.5"><Hammer className="w-3 h-3" /> Installation {dossier.produit ? `· ${dossier.produit}` : ""}</div>
        <button onClick={() => setOpen(true)} className="btn-primary text-sm" data-testid="envoi-pose-btn"><Send className="w-4 h-4" /> Envoi en pose</button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {rows.map((r) => (
          <div key={r.label} data-testid={`install-summary-${r.label}`}>
            <div className="text-[11px] text-norea-textMuted flex items-center gap-1"><r.icon className="w-3 h-3" /> {r.label}</div>
            <div className={`text-sm mt-0.5 ${r.value ? "text-norea-text font-medium" : "text-norea-textDisabled italic"}`}>{r.value || "À renseigner"}</div>
          </div>
        ))}
      </div>
      {last && (
        <div className="mt-3 text-[11px] text-emerald-700 flex items-center gap-1" data-testid="envoi-pose-last">
          <CheckCircle2 className="w-3 h-3" /> Envoyé en pose le {new Date(last).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}
          {ep.email_sent_at && " · email"}{ep.whatsapp_sent_at && " · WhatsApp"}
        </div>
      )}
      {open && <EnvoiPoseFlowModal dossier={dossier} onSent={() => setSentNow((x) => ({ ...x, email_sent_at: x.email_sent_at || new Date().toISOString() }))} onClose={() => { setOpen(false); load(); }} />}
    </div>
  );
}
